<template>
  <div class="space-y-8" v-auto-animate>
    <div class="space-y-1" v-if="fixtures?.length">
      <h2 class="font-heading font-bold text-2xl" v-html="$t('shared.nav.fixtures')" />
      <PartialsGames :games="fixtures" />
    </div>
    <div class="space-y-1" v-if="results?.length">
      <h2 class="font-heading font-bold text-2xl" v-html="$t('shared.nav.results')" />
      <PartialsGames :games="results" />
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const { data } = useFetch(`/api/v1/games`, { 
  key: `games`,
  baseURL: useEnv('apiBase'),
  query: {
    fromDate: useDate().subtract(30, 'day').format('YYYY-MM-DD'),
    untilDate: useDate().add(30, 'day').format('YYYY-MM-DD'),
  }
})

const now = useDate()
const oneWeekAhead = now.add(7, 'day')

// 1. Fixtures: Games from the last 7 days (based on first game date)
const fixtures = computed(() => {
  const upcomingGames = data.value?.games?.filter(g => !now.isAfter(g.startDate)) || []
  const upcomingDate = upcomingGames[0]?.startDate
  const weekBeforeLatest = useDate(upcomingDate).add(6, 'day')

  return upcomingGames
    ?.filter(g => weekBeforeLatest.isAfter(g.startDate))
})

// 2. Results: Games from the last 7 days (based on last game date)
const results = computed(() => {
  const pastGames = (data.value?.games?.filter(g => now.isAfter(g.startDate)) || [])?.reverse()
  const latestDate = pastGames[0]?.startDate
  const weekBeforeLatest = useDate(latestDate).subtract(6, 'day')

  return pastGames
    ?.filter(g => useDate(g.startDate).isSameOrAfter(weekBeforeLatest))
})
</script>